import "@/styles/components/site-header.css";
import { animate, stagger } from "motion";

const siteHeader = document.querySelector(".site-header");
const scrollPixel = document.querySelector(".scroll-pixel");
const siteMenu = document.getElementById("site-menu");

const prefersReducedMotion = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export default {
  init: () => {
    if (siteHeader && scrollPixel) {
      const observer = new IntersectionObserver(
        ([e]) => siteHeader.classList.toggle("is-stuck", e.intersectionRatio < 1),
        {
          threshold: [1],
        },
      );

      observer.observe(document.querySelector(".scroll-pixel"));
    }

    const setScrollLock = (locked) => {
      document.documentElement.classList.toggle("overflow-hidden", locked);
    };

    const siteMenuBg = siteMenu?.querySelector(".menu-bg");
    const siteMenuBrandMark = siteMenu?.querySelector(".menu-brand-mark");
    const siteMenuSocialItems = siteMenu?.querySelector(".menu-social")?.querySelectorAll("li") ?? [];

    document.documentElement.addEventListener("sitemenu:open", () => {
      setScrollLock(true);

      if (prefersReducedMotion()) {
        return;
      }

      animate([
        [siteMenuBg, { y: ["-33%", 0] }, { duration: 0.8, ease: "easeOut" }],
        [
          siteMenu.querySelectorAll(".menu-column"),
          { y: ["30px", 0], opacity: [0, 1] },
          { duration: 0.5, delay: stagger(0.2), ease: "easeOut", at: "<" },
        ],
        [
          siteMenu.querySelectorAll(".menu-actions li"),
          { y: ["30px", 0], opacity: [0, 1] },
          { duration: 0.3, delay: stagger(0.2), ease: "easeOut", at: "<0.5" },
        ],
        [siteMenuBrandMark, { y: ["30px", 0], opacity: [0, 1] }, { duration: 0.3, ease: "easeOut", at: "<0.5" }],
        [
          siteMenuSocialItems,
          { y: ["30px", 0], opacity: [0, 1] },
          { duration: 0.3, delay: stagger(0.2), ease: "easeOut", at: "<0.2" },
        ],
      ]);
    });

    document.documentElement.addEventListener("sitemenu:close", () => {
      setScrollLock(false);

      if (prefersReducedMotion()) {
        return;
      }

      animate([
        [siteMenu.querySelectorAll(".menu-column"), { opacity: 0 }, { duration: 0.2, ease: "easeOut" }],
        [siteMenu.querySelectorAll(".menu-actions li"), { opacity: [0] }, { duration: 0.2, ease: "easeOut", at: "<" }],
        [siteMenuBrandMark, { opacity: 0 }, { duration: 0.2, ease: "easeOut", at: "<" }],
        [siteMenuSocialItems, { opacity: 0 }, { duration: 0.2, ease: "easeOut", at: "<" }],
        [siteMenuBg, { y: "-33%" }, { duration: 0.4, ease: "easeOut" }],
      ]);
    });
  },
};
